import React, {MouseEvent, useState, useMemo} from 'react';
import Menu, {MenuProps} from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import {IoMdArrowDropdown} from 'react-icons/io';
import {useLocation, useNavigate} from 'react-router';
import {styled} from '@mui/material/styles';

const NavSubmenuToggle = styled('p')(({theme}) => ({
  color: theme.palette.secondary.main
}));

const StyledMenu = ((props: MenuProps) => {
  return (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      sx={{
        zIndex: 100000000000
      }}
      {...props}
    />
  )
});

interface Submenu {
  label: string;
  path: string;
}

interface MenuItem {
  submenus?: Submenu[];
}

interface UserDropDownProps {
  name: string;
  menuItem: MenuItem;
  overrideFontColor?: boolean;
}

export default function UserDropDown({name, menuItem, overrideFontColor}: UserDropDownProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const history = useNavigate()
  const location = useLocation()

  const endpoint = useMemo(() => {
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '');
    return pathSegments[pathSegments.length - 1] || '';
  }, [location.pathname])

  const handleClick = (event: MouseEvent<HTMLParagraphElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function handleRedirect(item: Submenu) {
    history(`/${item.path}`)
    handleClose()
  }

  return (
    <div>
      <NavSubmenuToggle
        onClick={handleClick}
        className={`ss-nav-submenu-toggle ${overrideFontColor ? `ss-account-menu-home` : 'ss-account-menu'}`}
      >
        {name}
        <IoMdArrowDropdown size={20}/>
      </NavSubmenuToggle>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className='ss-dropw-down-menu-main'
      >
        {menuItem?.submenus?.map((item, index) => (
          <MenuItem
            className={`${endpoint === item?.path ? `ss-drop-down-active` : `ss-dropw-down-inactive`}`}
            onClick={() => handleRedirect(item)} key={index}>
            <ListItemText className='ss-nav-drop-down-menu' primary={item?.label}/>
          </MenuItem>
        ))}
      </StyledMenu>
    </div>
  );
}
